import React from 'react';
import { Container, Alert, Box } from '@mui/material';
import Sidebar from '../Sidebar/Sidebar';
import useAuth from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

const NoLicenceActivated = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <>
      <Sidebar user={user} />
      <Container maxWidth="lg" sx={{ marginTop: '20px' }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100vh"
        >
          <Alert variant="outlined" severity="warning" sx={{ fontSize: '1.5rem' }}>
            {t('no_licence_activated.message')}
          </Alert>
        </Box>
      </Container>
    </>
  );
};

export default NoLicenceActivated;
